import { storage_configuration } from "../../authentication/firebaseStart";


const getURLFromGCSBucket = async (resUrl, companyID, fileName) => {
    let msg = "";
    let isError = false;
    let startRef = storage_configuration.refFromURL(resUrl);

    await startRef.getDownloadURL().then((url) => {
        // window.open(url)
        console.log('asdlasjbhdasd')
        let toDataURL = (url_arg, callback) => {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    console.log(reader)
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url_arg);
            xhr.responseType = 'blob';
            xhr.send();
        }
        toDataURL(url,
            (dataUrl) => {
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = today.getFullYear();

                today = dd + '-' + mm + '-' + yyyy;

                console.log(Date.now(), today + '_' + Date.now(), 'jfjfjfj')

                const a = document.createElement('a');
                a.href = dataUrl;

                a.download = `${fileName + '_' + today + '_' + Date.now()}.zip`;
                document.body.appendChild(a);
                a.style = 'display: none';
                a.click();
                a.remove();
            })

        isError = false;
        msg = "File download complete";

    }).catch((error) => {
        console.log("URL FETCHING [ERROR]:  ", error)
        // eslint-disable-next-line default-case
        switch (error.code) {
            case 'storage/object-not-found':
                console.log('File does not exist');
                isError = true;
                msg = "File does not exist";
                break;
            case 'storage/unauthorized':
                console.log('User does not have permission to access the object');
                isError = true;
                msg = "User does not have permission to access the object";
                break;
            case 'storage/canceled':
                console.log('User canceled the upload')
                isError = true;
                msg = "User canceled the upload";
                break;
            case 'storage/unknown':
                console.log('Unknown error occurred, inspect the server response')
                isError = true;
                msg = "Unknown error occurred, inspect the server response";
                break;
        }
    })
    return [isError, msg]
}

export {
    getURLFromGCSBucket
};
